import { Button, Icon, Modal } from '../../ui'
import { partnershipData } from './data'
import styles from './PartnershipPage.module.css'

export function TierCompareDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Modal
      open={open}
      title={partnershipData.copy.compareTitle}
      onClose={onClose}
      footer={<Button onClick={onClose}>{partnershipData.copy.compareClose}</Button>}
    >
      <table className={styles.compareTable}>
        <thead>
          <tr>{partnershipData.copy.compareCols.map((column) => <th key={column}>{column}</th>)}</tr>
        </thead>
        <tbody>
          {partnershipData.tiers.map((tier) => (
            <tr key={tier.key}>
              <td>
                <span className={styles.compareTierName}>{tier.name}</span>
                {tier.recommended ? <span className={styles.compareRecommended}><Icon name="sparkle" size={12} />{partnershipData.copy.aiMatchLabel}</span> : null}
              </td>
              <td className="mono-num">{tier.unit.replace('单商品每月 ', '')}</td>
              <td>{partnershipData.benefits.join(' · ')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </Modal>
  )
}
